// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PreLoader_overlay__QUGfT"};